import router from './router';
import axios from 'axios'
import {apis} from './core/apis';
import * as appUtils from './core/appUtils';
import NProgress from 'nprogress' // progress bar
import  {ConstStatic} from './core/constStatic'
import '@/components/NProgress/nprogress.less' // progress bar custom style
import notification from 'ant-design-vue/es/notification'

NProgress.configure({showSpinner: false}) // NProgress Configuration

const whiteList = ['login'];
const defaultRoutePath = '/home'

// router.beforeEach((to, from, next) => {
//     NProgress.start() // start progress bar
//     let jti = to.query.jti || '';
//     if (jti) {
//       console.log(9999999999999999);
//         appUtils.setLocalStorage(ConstStatic.JTI, jti);S
//         //此处需要换成广州传过来的参数，来换用户信息以及角色。
//         axios({ //换用户信息
//             method: 'get',
//             url: apis.api.system.checkToken + jti //动态获取
//         }).then((res) => {
//             if (res.data.status == 0) {
//                 appUtils.setLocalStorage(ConstStatic.TOKEN_KEY, res.data.access_token);
//                 appUtils.setLocalStorage(ConstStatic.USER_INFO, res.data.data);
//                 next();
//             } else if (res.data.status == 1001) {
//                 notification.error({
//                     message: '错误',
//                     description: '登录超时，重新登录'
//                 })
//                 appUtils.removeLocalStorage(ConstStatic.TOKEN_KEY);
//                 // window.location.href = appUtils.getDomainUrl()+'/login';
//             }
//         }).catch((err) => {
//             notification.error({
//                 message: '错误',
//                 description: '登录超时，重新登录'
//             })
//             appUtils.removeLocalStorage(ConstStatic.TOKEN_KEY);
//             // window.location.href = appUtils.getDomainUrl()+'/login';
//         });
//     } else {
//         if (appUtils.getToken()) {
//             /* has token */
//             if (to.path === '/login') {
//                 next({path: defaultRoutePath})
//                 NProgress.done()
//             } else {
//                 next();
//                 NProgress.done()
//             }
//         } else {
//             if (whiteList.includes(to.name)) {
//                 // 在免登录白名单，直接进入
//                 next()
//             } else {
//                 notification.error({
//                     message: '错误',
//                     description: '登录失效，重新登录'
//                 })
//                 next({path: '/login', query: {redirect: to.fullPath}})
//                 NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
//                 // window.location.href = appUtils.getDomainUrl()+'/login';
//             }
//         }
//     }
// })
router.afterEach(() => {
    NProgress.done() // finish progress bar
})